// src/services/onboardingService.js
import axios from "axios";
import { onboardingUrl , confirmOnboarding , paymentOnboardingInitiate , verifyOnboardingPayment, getOnboardingUserDetails, pricingPlan} from "src/react-query/endPoints";

async function submitOnboarding(payload) {
  return await axios.post(onboardingUrl(), payload);
}

async function resendVerificationEmail(payload) {
  return await axios.post(resendVerificationEmail(), payload);
}

async function confirmOnboardingEmail(token){
  return await axios.get(confirmOnboarding(token));
}

async function initiatePaymentOnboarding(payload) {
  return await axios.post(paymentOnboardingInitiate(), payload);
}

async function verifyPaymentOnboarding(payload) {
  return await axios.post(verifyOnboardingPayment(), payload);
}

async function getOnboardingUserData(userId) {
  return await axios.get(getOnboardingUserDetails(userId));
}

async function getPricingPlan(country) {
  return await axios.get(pricingPlan(country));
}



const onboardingService = {
  submitOnboarding,
  confirmOnboardingEmail,
  initiatePaymentOnboarding,
  verifyPaymentOnboarding,
  resendVerificationEmail,
  getOnboardingUserData,
  getPricingPlan,
};

export default onboardingService;